import React, { useState, useEffect } from 'react';
import { get, post } from '../../../ApiServices/ApiServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useForm } from "react-hook-form";
import { clearSize } from '../../../redux/profileSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import MemberDetail from './MemberDetail';
import Memberstyle from './Memberstyle';
import Description from './Description';
import MemberOrderReview from './MemberOrderReview';
import Loader from '../../Component/Loader';
import Container from '../../../Container/Container';
function MemberParent() {
    const [step, setStep] = useState(1);
    const [Helper, setHelper] = useState(false);
    const [id, setid] = useState(null)
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch();
    const Help = location.state?.Helper
    const memberId = location.state?.memberId;
    const profile = useSelector((state) => state.profile.profile);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (!memberId) {
            navigate(-1);
        }
    }, [memberId, navigate]);

    useEffect(() => {
        if (Help) {
            setHelper(Help)
        }
    }, [Help])

    const [showShirt, setShowShirt] = useState(true);
    const [showVest, setShowVest] = useState(true);
    const [showShoes, setShowShoes] = useState(true);
    const [showTie, setShowTie] = useState(true)
    const [Showjewelry, setShowjewelry] = useState(true)
    const [ShowPocket, setShowPocket] = useState(true)
    const [Showcoat, setShowcoat] = useState(true)
    const [ShowPant, setShowPant] = useState(true)
    const [Singledata, setSingledata] = useState([])
    const [CopyOrder, setCopyOrder] = useState(false)
    const [ForStatus, setForStatus] = useState(false)
    const { setValue } = useForm();

    const Singleorder = async () => {
        try {
            setLoading(true); // Start loading

            const api = `wedding-member/${memberId}`;
            const response = await get(api);
            if (response?.status == true) {
                setSingledata(response?.data);
                setid(response?.data?.wedding_id)
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (memberId) {
            Singleorder()
        }
    }, [memberId])

    // MemberParent.jsx - Singleorder data load hone ke baad
    useEffect(() => {
        if (Singledata) {
            // Agar existing order mein belt hai aur wo shoe color se alag hai
            // toh manually changed maano
            const existingBelt = pant?.belt;
            const existingShoeColor = shoes?.inventory?.shoe_color;

            if (existingBelt && existingBelt !== existingShoeColor) {
                localStorage.setItem("isBeltManuallyChanged", "true");
                localStorage.setItem("manualBeltColor", existingBelt);
            } else {
                localStorage.removeItem("isBeltManuallyChanged");
                localStorage.removeItem("manualBeltColor");
            }
        }
    }, [Singledata]);
    const { wedding_style = [] } = Singledata;
    const coat = wedding_style.find(item => item.inventory_category_type === "Coats");
    const pant = wedding_style.find(item => item.inventory_category_type === "Pants");
    const shirt = wedding_style.find(item => item.inventory_category_type === "Shirt");
    const vest = wedding_style.find(item => item.inventory_category_type === "Vests");
    const tie = wedding_style.find(item => item.inventory_category_type === "Ties");
    const pocketSquare = wedding_style.find(item => item.inventory_category_type === "PocketSquare");
    const jewellery = wedding_style.find(item => item.inventory_category_type === "Jewellery");
    const shoes = wedding_style.find(item => item.inventory_category_type === "Shoes");
    const requestedByUserId =
        profile?.name === "Admin"
            ? profile?.id                 // Admin ID
            : Singledata?.user?.id || Singledata?.user_id; // Customer ID
    useEffect(() => {
        const serializedData = JSON.stringify(coat?.inventory);
        localStorage.setItem('coatStyle', serializedData);
        localStorage.setItem('coatid', coat?.size);
        console.log(coat?.size_chart_category_id, "coat?.size_chart_category_id");

        if (coat?.size_chart_category_id != null) {
            localStorage.setItem('size', coat?.size_chart_category_id);
        }


    }, [coat])

    useEffect(() => {
        const serializedData = JSON.stringify(shirt?.inventory);
        localStorage.setItem('shirtstyle', serializedData);

        if (shirt?.size_chart_category_id != null) {
            localStorage.setItem('size', shirt?.size_chart_category_id);
        }
    }, [shirt])

    useEffect(() => {
        const serializedData = JSON.stringify(pant?.inventory);
        localStorage.setItem('pantstyle', serializedData);

        if (pant?.size_chart_category_id != null) {
            localStorage.setItem('size', pant?.size_chart_category_id);
        }
    }, [pant])


    useEffect(() => {
        const serializedData = JSON.stringify(vest?.inventory);
        localStorage.setItem('Veststyle', serializedData);

        if (vest?.size_chart_category_id != null) {
            localStorage.setItem('size', vest?.size_chart_category_id);
        }
    }, [vest])


    useEffect(() => {
        const serializedData = JSON.stringify(shoes?.inventory);
        localStorage.setItem('Shoes', serializedData);
    }, [shoes])

    function convertHeightToInches(height) {
        // handle null, undefined, empty, 0
        if (height === null || height === undefined || height === "" || height === 0) {
            return "";
        }

        // if height is already a number (ex: 502, 63)
        if (typeof height === "number") {
            return height;
        }

        // if height is string like 5'2"
        if (typeof height === "string") {
            const parts = height.split(/'|"/);
            const feet = parseInt(parts[0], 10) || 0;
            const inches = parseInt(parts[1], 10) || 0;
            return feet * 12 + inches;
        }

        return "";
    }

    console.log(Singledata?.member_height, "Singledata?.member_height")
    // Example usage:
    const height = Singledata?.member_height;
    const heightInInches = height != null ? convertHeightToInches(height) : "null"; // Returns 63
    console.log(heightInInches, "heightInInches--------------")
    useEffect(() => {
        if (Singledata) {
            setFormData(prev => ({
                ...prev,
                // Personal Details
                Weddingdate: Helper == false ? (Singledata.event_date || "") : "",
                order_for: Singledata.order_for || "Men",
                // ordertype: Singledata.order_type || "",                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    
                Firstname: Singledata.first_name || "",
                Lastname: Singledata.last_name || "",
                Address: Singledata.address || "",
                State: Singledata.state || "",
                City: Singledata.city || "",
                ZipCode: Singledata.zip_code || "",
                PhoneNumber: Singledata.phone || "",
                EmailAddress: Singledata.email || "",
                school: Singledata.school || "",

                AlterAcc: Singledata?.account,
                AccountId: Singledata?.user_id,

                // order_type: Singledata.order_type || "",
                AlternatePickup: Singledata.is_alt_pickup_enable,
                Affiliated_store: Singledata.store,
                requested_by_user_id: requestedByUserId,
                dropShippingswitch: Singledata.is_drop_ship_enable,
                weddingRole: Singledata?.wedding_role_id ? String(Singledata.wedding_role_id) : "",


                dropShipping: {
                    name: Singledata.name,
                    addressLine1: Singledata.shipping_address,
                    addressLine2: Singledata.shipping_address_line2,
                    city: Singledata.shipping_city,
                    state: Singledata.shipping_state,
                    zipCode: Singledata.shipping_zip,
                    phone: Singledata.shipping_phone,
                },

                Height:
                    heightInInches != "null"
                        ? (heightInInches == 0 ? "Unknown" : heightInInches)
                        : (Singledata?.is_csv == true ? "Unknown" : ""),
                Weight: Singledata?.member_weight ? Singledata?.member_weight : Singledata?.is_csv == true ? "999" : "",



                Chest: Singledata?.member_chest || "",
                Overarm: Singledata?.member_overarm || "",

                Coat: coat?.style || "",
                CoatSize: coat?.size || "",
                Insleeve: coat?.insleeve || localStorage.getItem("Insleeve") || "",

                belt: pant?.belt || "",

                Pant: pant?.style || "",
                Waist: pant?.size || "",
                hip: pant?.hip || "",
                outseam: pant?.outseam || "",

                shirt_size: shirt?.shirt_size || "",
                Shirt: shirt?.style || "",
                ShirtSize: shirt?.size || "",
                Sleeve: shirt?.sleeve || "",

                Vest: vest?.style || "",
                VestColor: vest?.size || "",

                Tie: tie?.style || "",
                Pocket: pocketSquare?.style || "",
                Jewelry: jewellery?.style || "",
                Shoes: shoes?.style || "",
                ShoesSize: shoes?.size || "",
                shoe_color: shoes?.inventory?.shoe_color,

                Rentalterm: Singledata?.rental_term || "1 week",
                Notes: Singledata?.notes || "",
                SubmittedBy: Singledata.submitted_by || "",
                coatinventory_id: coat?.inventory_id || "",
                Paintinventory_id: pant?.inventory_id || "",
                shirtInventory_id: shirt?.inventory_id || "",
                VestInventory_id: vest?.inventory_id || "",
                TieInventory_id: tie?.inventory_id || "",
                PocketInventory_id: pocketSquare?.inventory_id || "",
                jewelryinventory_id: jewellery?.inventory_id || "",
                ShoesInventory_id: shoes?.inventory_id || "",
            }));
        }
    }, [Singledata]);


    const [formData, setFormData] = useState({
        // Personal Details
        Weddingdate: Helper == false ? (Singledata.event_date || "") : "",
        // ordertype: Singledata.order_type || "",
        Firstname: Singledata.first_name || "",
        Lastname: Singledata.last_name || "",
        Address: Singledata.address || "",
        State: Singledata.state || "",
        City: Singledata.city || "",
        ZipCode: Singledata.zip_code || "",
        PhoneNumber: Singledata.phone || "",
        EmailAddress: Singledata.email || "",
        school: Singledata.school || "",
        belt: pant?.belt || "",
        size_chart_id: "",
        order_for: Singledata.order_for || "Men",
        // order_type: Singledata.order_type || "",
        Affiliated_store: "",
        store_id: null,
        is_logging: "false",
        requested_by_user_id: requestedByUserId,
        AlterAcc: Singledata?.account,
        AccountId: Singledata?.user_id,
        weddingRole: Singledata?.wedding_role_id ? String(Singledata.wedding_role_id) : "",

        // Drop Shipping
        dropShippingswitch: Singledata.is_drop_ship_enable,
        dropShipping: {
            name: Singledata.name || "",
            addressLine1: Singledata.shipping_address || "",
            addressLine2: Singledata.shipping_address_line2 || "",
            city: Singledata.shipping_city || "",
            state: Singledata.shipping_state || "",
            zipCode: Singledata.shipping_zip || "",
            phone: Singledata.shipping_phone || "",
        },

        // Measurements
        // Height: heightInInches ? heightInInches : Singledata?.is_csv == true ? "Unknown" : "Unknown",

        Height:
            heightInInches != "null"
                ? (heightInInches == 0 ? "Unknown" : heightInInches)
                : (Singledata?.is_csv == true ? "Unknown" : ""),
        Weight: Singledata?.member_weight ? Singledata?.member_weight : Singledata?.is_csv == true ? "999" : "",

        Weightwo: "",
        Overarm: Singledata?.member_overarm || "",
        Coat: coat?.style || "",
        CoatSize: coat?.size || "",
        Insleeve: "",
        Pant: pant?.style,
        PantSize: "",
        Shirt: shirt?.style || "",
        ShirtSize: shirt?.size || "",
        Sleeve: shirt?.Sleeve || "",
        Vest: vest?.style || "",
        VestColor: vest?.size || "",
        outseam: pant?.outseam || "",
        Chest: Singledata?.member_chest || "",
        Tie: tie?.style || "",
        hip: pant?.hip || "",
        Pocket: pocketSquare?.style || "",
        Jewelry: jewellery?.style || "",
        Shoes: shoes?.style || "",
        ShoesSize: shoes?.size || "",
        style: "",
        Waist: pant?.size,
        Rentalterm: Singledata?.rental_term || "1 week",
        shirt_size: shirt?.shirt_size,
        // Other fields
        AlternatePickup: false,
        Affiliated_store: "",
        // Inventory IDs
        coatinventory_id: coat?.inventory_id || "",
        Paintinventory_id: pant?.inventory_id || "",
        shirtInventory_id: shirt?.inventory_id || "",
        VestInventory_id: vest?.inventory_id || "",
        TieInventory_id: tie?.inventory_id || "",
        PocketInventory_id: pocketSquare?.inventory_id || "",
        jewelryinventory_id: jewellery?.inventory_id || "",
        ShoesInventory_id: shoes?.inventory_id || "",
        // size_chart_category_id: "",
        size_chart_category_id: Singledata?.size_chart_category_id || "",
        // Description
        Notes: Singledata?.notes || "",
        SubmittedBy: Singledata.submitted_by || "",
        NextSlip: ""
    });

    const onNextStep = (data) => {
        setFormData(prevData => ({
            ...prevData,
            ...data
        }));
        setStep(step + 1);
    };

    const onBackStep = () => {
        setStep(step - 1);
    };
    function convertInchesToFeet(inches) {
        if (!inches || isNaN(inches)) return `0'0"`;

        let feet = Math.floor(inches / 12);
        let remainingInches = inches % 12;

        return `${feet}'${remainingInches}"`;
    }
    const onFormSubmit = async (addressData, isValid) => {
        const size = localStorage.getItem("selectedCategoryName");

        const { wedding_style = [] } = Singledata || {};
        const coat = wedding_style.find(item => item.inventory_category_type === "Coats") || null;
        const pant = wedding_style.find(item => item.inventory_category_type === "Pants") || null;
        const shirt = wedding_style.find(item => item.inventory_category_type === "Shirt") || null;
        const vest = wedding_style.find(item => item.inventory_category_type === "Vests") || null;
        const tie = wedding_style.find(item => item.inventory_category_type === "Ties") || null;
        const pocketSquare = wedding_style.find(item => item.inventory_category_type === "PocketSquare") || null;
        const jewellery = wedding_style.find(item => item.inventory_category_type === "Jewellery") || null;
        const shoes = wedding_style.find(item => item.inventory_category_type === "Shoes") || null;

        setFormData(prevData => ({
            ...prevData,
            ...addressData
        }));
        const finalData = {
            ...formData,
            ...addressData
        };

        let convertedHeight = convertInchesToFeet(finalData?.Height);

        // useEffect(() => {
        //     console.log(localStorage.getItem('selectedCategoryId'), "localStorage.getItem('selectedCategoryId')")
        // }, [])

        const updata = {
            is_logging: "true",
            first_name: finalData?.Firstname,
            last_name: finalData?.Lastname,
            address: finalData?.Address || null,
            state: finalData?.State || null,
            city: finalData?.City || null,
            zip_code: finalData?.ZipCode || null,
            phone: finalData?.PhoneNumber || null,
            email: finalData?.EmailAddress || null,
            // school: finalData?.order_type == "Prom Order" ? finalData?.school : "",

            ...(profile?.name == "Admin" && {
                user_id: finalData?.AccountId || null,
            }),
            account: finalData?.AlterAcc || profile?.account,

            is_alt_pickup_enable: finalData?.AlternatePickup || false,
            is_drop_ship_enable: finalData?.dropShippingswitch || false,
            name: finalData?.dropShipping?.name || null,
            shipping_address: finalData?.dropShipping?.addressLine1 || null,
            shipping_address_line2: finalData?.dropShipping?.addressLine2 || null,
            shipping_city: finalData?.dropShipping?.city || null,
            shipping_state: finalData?.dropShipping?.state || null,
            shipping_zip: finalData?.dropShipping?.zipCode || null,
            shipping_phone: finalData?.dropShipping?.phone || null,
            wedding_role_id: finalData?.weddingRole
                ? parseInt(finalData.weddingRole)
                : formData?.weddingRole          // ← fallback formData se lo
                    ? parseInt(formData.weddingRole)
                    : null,


            member_height: convertedHeight || null,
            member_weight: finalData?.Weight || null,
            member_chest: finalData?.Chest || null,
            member_overarm: finalData?.Overarm || null,
            rental_term: finalData?.Rentalterm || "1 week",


            order_for: finalData?.order_for || null,
            submitted_by: finalData?.SubmittedBy || null,
            notes: finalData?.Notes || null,
            // order_type: finalData?.order_type || null,
            store: finalData?.Affiliated_store || null,
            store_id: finalData?.store_id || null,
            requested_by_user_id: finalData?.requested_by_user_id,

            // && finalData.hip
            status_id: step == 3
                ? (
                    (finalData?.Coat && !finalData?.CoatSize) ||
                        (finalData?.Pant && !(finalData?.Waist && finalData.outseam)) ||
                        (finalData?.Shirt && !finalData?.ShirtSize) ||
                        (finalData?.Vest && !finalData?.VestColor) ||
                        (finalData?.Shoes && !finalData?.ShoesSize)
                        ? ((Singledata?.status_id == 1 || Singledata?.status_id == 2) ? 1 : 16)

                        : Singledata?.status_id == 1 ? 2 : undefined)
                :
                (
                    (finalData?.Coat && !finalData?.CoatSize) ||
                        (finalData?.Pant && !(finalData?.Waist && finalData.outseam)) ||
                        (finalData?.Shirt && !finalData?.ShirtSize) ||
                        (finalData?.Vest && !finalData?.VestColor) ||
                        (finalData?.Shoes && !finalData?.ShoesSize)
                        ? ((Singledata?.status_id == 1 || Singledata?.status_id == 2) ? 1 : 16)
                        : Singledata?.status_id == 1 ? 2 : undefined
                ),


            stylesDataForMembers: [
                (coat && !finalData?.Coat) ? {
                    "id": coat.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Coat && {
                        ...(coat ? { id: coat.id } : {}),
                        inventory_category_id: 1,
                        inventory_category_type: "Coats",
                        inventory_id: finalData?.coatinventory_id || null,
                        style: finalData?.Coat || null,
                        // size_chart_category_id: finalData.size_chart_category_id
                        //     ? parseInt(finalData.size_chart_category_id)
                        //     : null,
                        // size_chart_category_id: finalData.size_chart_category_id
                        //     ? parseInt(finalData.size_chart_category_id)
                        //     : (sizeid ? parseInt(sizeid) : null),
                        size_chart_category_id:
                            size === "Boys" ? 1 :
                                size === "Short" ? 2 :
                                    size === "Regular" ? 3 :
                                        size === "Long" ? 4 :
                                            size === "Extra Long" ? 5 : null,

                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.CoatSize || null,
                        insleeve: String(finalData.Insleeve) || null,
                        size_chart_category_name: finalData.categoryName || localStorage.getItem('selectedCategoryName') || null
                    },



                (pant && !finalData?.Pant) ? {
                    "id": pant.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Pant && {
                        ...(pant ? { id: pant.id } : {}),
                        inventory_category_id: 2,
                        inventory_id: finalData?.Paintinventory_id || null,
                        inventory_category_type: "Pants",
                        style: finalData?.Pant || null,
                        // size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        // ? finalData?.size_chart_category_id
                        //     : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_category_id:
                            size === "Boys" ? 1 :
                                size === "Short" ? 2 :
                                    size === "Regular" ? 3 :
                                        size === "Long" ? 4 :
                                            size === "Extra Long" ? 5 : null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.Waist || null,
                        hip: String(finalData.hip) || null,
                        outseam: String(finalData.outseam) || null,
                        belt: finalData.belt || null,
                    },


                (shirt && !finalData?.Shirt) ? {
                    "id": shirt.id,
                    "isDeleted": true
                }
                    : finalData?.Shirt && {
                        ...(shirt ? { id: shirt.id } : {}),
                        inventory_category_id: 3,
                        inventory_id: finalData?.shirtInventory_id || null,
                        inventory_category_type: "Shirt",
                        style: finalData?.Shirt || null,
                        // size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        //     ? finalData?.size_chart_category_id
                        //     : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_category_id:
                            size === "Boys" ? 1 :
                                size === "Short" ? 2 :
                                    size === "Regular" ? 3 :
                                        size === "Long" ? 4 :
                                            size === "Extra Long" ? 5 : null,

                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.ShirtSize || null,
                        shirt_size: finalData?.shirt_size || null,
                        sleeve: String(finalData.Sleeve) || null
                    },
                (vest && !finalData?.Vest) ? {
                    "id": vest.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Vest && {
                        ...(vest ? { id: vest.id } : {}),
                        inventory_category_id: 4,
                        inventory_id: finalData?.VestInventory_id || null,
                        inventory_category_type: "Vests",
                        style: finalData?.Vest || null,
                        // size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        //     ? finalData?.size_chart_category_id
                        //     : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_category_id:
                            size === "Boys" ? 1 :
                                size === "Short" ? 2 :
                                    size === "Regular" ? 3 :
                                        size === "Long" ? 4 :
                                            size === "Extra Long" ? 5 : null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.VestColor || null
                    },
                // finalData?.Tie

                (tie && !finalData?.Tie) ? {
                    "id": tie.id,
                    "isDeleted": true
                }
                    : finalData?.Tie && {
                        ...(tie ? { id: tie.id } : {}),
                        inventory_category_id: 5,
                        inventory_category_type: "Ties",
                        inventory_id: finalData?.TieInventory_id || null,
                        style: finalData?.Tie || null
                    },
                // finalData?.Pocket &&

                (pocketSquare && !finalData?.Pocket) ? {
                    "id": pocketSquare.id,
                    "isDeleted": true
                }
                    :
                    finalData?.Pocket && {
                        ...(pocketSquare ? { id: pocketSquare.id } : {}),
                        inventory_category_id: 8,
                        inventory_category_type: "PocketSquare",
                        inventory_id: finalData?.PocketInventory_id || null,
                        style: finalData?.Pocket || null
                    },

                (jewellery && !finalData?.Jewelry) ? {
                    "id": jewellery.id,
                    "isDeleted": true
                }
                    : finalData?.Jewelry && {
                        ...(jewellery ? { id: jewellery.id } : {}),

                        inventory_category_id: 9,
                        inventory_category_type: "Jewellery",
                        inventory_id: finalData?.jewelryinventory_id || null,
                        style: finalData?.Jewelry || null
                    },

                (shoes && !finalData?.Shoes) ? {
                    "id": shoes.id,
                    "isDeleted": true
                }
                    : finalData?.Shoes && {
                        ...(shoes ? { id: shoes.id } : {}),
                        inventory_category_id: 7,
                        inventory_category_type: "Shoes",
                        inventory_id: finalData?.ShoesInventory_id || null,
                        style: finalData?.Shoes || null,
                        // size_chart_category_id: isNaN(parseInt(finalData?.size_chart_category_id))
                        //     ? finalData?.size_chart_category_id
                        //     : parseInt(finalData?.size_chart_category_id) || null,
                        size_chart_category_id:
                            size === "Boys" ? 1 :
                                size === "Short" ? 2 :
                                    size === "Regular" ? 3 :
                                        size === "Long" ? 4 :
                                            size === "Extra Long" ? 5 : null,
                        size_chart_id: finalData?.coat_size_chart_id || null,
                        size: finalData?.ShoesSize || null
                    }
            ].filter(Boolean)
        };

        console.log(updata, "updataupdata");
        try {
            setIsSubmitting(true);
            const api = `update-wedding-member/${id}/${memberId}`
            const totalData = await post(api, updata);
            Singleorder()
            toast.success(totalData?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });

            if (!id || Helper == true) {
                setid(totalData?.data?.id)
            }
            if (step == 4) {
                navigate(-1)
            }
            else {
                setStep(step + 1);
            }
            setIsSubmitting(false);
            setHelper(false);
            setShowShirt(true);
            setShowTie(true);
            setShowVest(true);
            setShowShoes(true);
            setShowPocket(true);
            setShowjewelry(true);
            setShowcoat(true);
            setShowPant(true);
        }
        catch (error) {
            setIsSubmitting(false);
            toast.error(error.message || 'Failed to submit form. Please try again.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            navigate(-1)
        }
    };

    const onFinalSubmit = async () => {
        setIsSubmitting(true)
        try {
            let api;
            let Data;

            if (showShirt && showVest && showShoes && showTie && Showjewelry && ShowPocket && Showcoat && ShowPant) {
                api = id ? `confirm-single-order/${id}` : '';
                Data = {
                    status_id: 2
                };
                var totalData = await post(api, Data);
            } else {
                onFormSubmit()
            }


            navigate("/single-order")
            toast.success(totalData?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });

            setFormData({
                // Personal Details
                Weddingdate: "",
                ordertype: "",
                Firstname: "",
                Lastname: "",
                Address: "",
                State: "",
                City: "",
                ZipCode: "",
                phoneNumber: "",
                EmailAddress: "",
                school: "",
                size_chart_id: "",
                order_for: "Men",
                order_type: "",
                store_id: null,
                requested_by_user_id: null,


                AlterAcc: "",
                AccountId: null,
                // Drop Shipping
                dropShippingswitch: false,
                dropShipping: {
                    name: "",
                    addressLine1: "",
                    addressLine2: "",
                    city: "",
                    state: "",
                    zipCode: "",
                    phone: ""
                },

                // Measurements
                Height: "",
                Weight: "",
                Weightwo: "",
                Overarm: "",
                Coat: "",
                CoatSize: "",
                Insleeve: "",
                Pant: "",
                PantSize: "",
                Shirt: "",
                ShirtSize: "",
                belt: "",
                Sleeve: "",
                Vest: "",
                VestColor: "",
                outseam: "",
                Chest: "",
                Tie: "",
                hip: "",
                Pocket: "",
                Jewelry: "",
                Shoes: "",
                ShoesSize: "",
                style: "",
                Waist: "",
                Rentalterm: "1 week",
                // Other fields
                AlternatePickup: false,
                Affiliated_store: "",

                // Inventory IDs
                coatinventory_id: "",
                Paintinventory_id: "",
                shirtInventory_id: "",
                VestInventory_id: "",
                TieInventory_id: "",
                PocketInventory_id: "",
                jewelryinventory_id: "",
                ShoesInventory_id: "",
                size_chart_category_id: "",
                // Description
                Notes: "",
                SubmittedBy: "",
                NextSlip: ""
            });
            localStorage.removeItem('coatStyle');
            localStorage.removeItem('pantstyle');
            localStorage.removeItem('shirtstyle');
            localStorage.removeItem('Veststyle');
            localStorage.removeItem('size');
            localStorage.removeItem('coatid');
            setStep(1);
            setid(null)
            dispatch(clearSize());
            setIsSubmitting(false)

        }
        catch (error) {
            toast.error(error.message || 'Failed to submit form. Please try again.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            setIsSubmitting(false)
        }
    };

    window.addEventListener('beforeunload', () => {
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('pantstyle');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('Veststyle');
        localStorage.removeItem('size');
        localStorage.removeItem('coatid');
    });

    useEffect(() => {
        localStorage.removeItem('coatStyle');
        localStorage.removeItem('pantstyle');
        localStorage.removeItem('shirtstyle');
        localStorage.removeItem('Veststyle');
        localStorage.removeItem('size');
        localStorage.removeItem('coatid');
    }, [])

    const RestShirt = () => {
        setShowShirt(false)
        setValue("shirtInventory_id", null);
        setValue("Shirt", "");
        setValue("ShirtSize", "");
        setValue("Sleeve", "");
        setFormData(prevData => ({
            ...prevData,
            shirtInventory_id: null,
            Shirt: "",
            ShirtSize: "",
            Sleeve: ""
        }));
        localStorage.removeItem('shirtstyle');
    };

    const ResetVest = () => {
        setShowVest(false);
        setValue("VestInventory_id", null);
        setValue("Vest", "");
        setValue("VestColor", "");
        setFormData(prevData => ({
            ...prevData,
            VestInventory_id: null,
            Vest: "",
            VestColor: "",
        }));
        localStorage.removeItem('Veststyle');
    }


    const ResetShoe = () => {
        setShowShoes(false)
        setValue("ShoesInventory_id", null);
        setValue("Shoes", "");
        setValue("ShoesSize", "");
        setFormData(prevData => ({
            ...prevData,
            ShoesInventory_id: null,
            Shoes: "",
            ShoesSize: "",
        }));
    }

    const RecetTie = () => {
        setShowTie(false)
        setValue("TieInventory_id", null);
        setValue("Tie", "");
        setFormData(prevData => ({
            ...prevData,
            TieInventory_id: null,
            Tie: "",
        }));
    }

    const RecetPocket = () => {
        setShowPocket(false)
        setValue("PocketInventory_id", null);
        setValue("Pocket", "");
        setFormData(prevData => ({
            ...prevData,
            PocketInventory_id: null,
            Pocket: "",
        }));
    }



    const RecetCoat = () => {
        setValue("coatinventory_id", null);
        setValue("Coat", "");
        setValue("CoatSize", "");
        setValue("Insleeve", "");
        localStorage.removeItem('coatid');
        localStorage.removeItem('size');
        localStorage.removeItem('coatStyle');

        setFormData(prevData => ({
            ...prevData,
            coatinventory_id: null,
            Coat: "",
            CoatSize: "",
            Insleeve: "",
        }));
    }



    const RecetPant = () => {
        setShowPant(false)
        setValue("Paintinventory_id", null);
        setValue("Pant", "");
        setValue("Waist", "");
        setValue("hip", "");
        setValue("outseam", "");
        localStorage.removeItem('pantstyle');
        setFormData(prevData => ({
            ...prevData,
            Paintinventory_id: null,
            Pant: "",
            Waist: "",
            hip: "",
            outseam: "",
        }));
    }

    const ResetJewelry = () => {
        setShowjewelry(false)
        setValue("jewelryinventory_id", null);
        setValue("Jewelry", "");
        setFormData(prevData => ({
            ...prevData,
            jewelryinventory_id: null,
            Jewelry: "",
        }));
    }


    if (loading && step != 4) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <Loader />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <div>
            {step === 1 && (
                <MemberDetail
                    key="step1"
                    onNext={onNextStep}
                    ticket={Singledata?.ticket || ""}
                    account={Singledata?.account || ""}
                    initialValues={{
                        Weddingdate: formData.Weddingdate,
                        order_type: formData.order_type,
                        Firstname: formData.Firstname,
                        Lastname: formData.Lastname,
                        Address: formData.Address,
                        State: formData.State,
                        City: formData.City,
                        ZipCode: formData.ZipCode,
                        PhoneNumber: formData.PhoneNumber,
                        EmailAddress: formData.EmailAddress,
                        school: formData.school,
                        wedding_role_id: formData.weddingRole,  // ← add this

                        AlterAcc: formData.AlterAcc,
                        AccountId: formData.AccountId,

                        dropShipping: formData.dropShipping,
                        dropShippingswitch: formData.dropShippingswitch,
                        AlternatePickup: formData.AlternatePickup,
                        Affiliated_store: formData.Affiliated_store,
                        store_id: formData.store_id,
                    }}
                />
            )}

            {step === 2 && (
                <Memberstyle
                    key="step3"
                    onNext={onNextStep}
                    onBack={onBackStep}
                    ticket={Singledata?.ticket || ""}
                    account={Singledata?.account || ""}
                    initialValues={{
                        Height: formData.Height,
                        Weight: formData.Weight,
                        Weightwo: formData.Weightwo,
                        Overarm: formData.Overarm,
                        Coat: formData.Coat,
                        CoatSize: formData.CoatSize,
                        Insleeve: formData.Insleeve,
                        Pant: formData.Pant,
                        Firstname: formData.Firstname,
                        Lastname: formData.Lastname,
                        PantSize: formData.PantSize,
                        Shirt: formData.Shirt,
                        ShirtSize: formData.ShirtSize,
                        Sleeve: formData.Sleeve,
                        Vest: formData.Vest,
                        VestColor: formData.VestColor,
                        Tie: formData.Tie,
                        Pocket: formData.Pocket,
                        Jewelry: formData.Jewelry,
                        Shoes: formData.Shoes,
                        ShoesSize: formData.ShoesSize,
                        shoe_color: formData.shoe_color,

                        outseam: formData.outseam,
                        belt: formData.belt,
                        Chest: formData.Chest,
                        style: formData.style,
                        hip: formData.hip,
                        shirt_size: formData?.shirt_size,
                        Rentalterm: formData.Rentalterm || "1 week",
                        order_for: formData.order_for,
                        Waist: formData.Waist,
                        size_chart_id: formData.size_chart_id,
                    }}
                />
            )}
            {step == 3 && (
                <Description
                    key="step4"
                    onSubmit={onFormSubmit}
                    ticket={Singledata?.ticket || ""}
                    account={Singledata?.account || ""}
                    onBack={onBackStep}
                    initialValues={{
                        Notes: formData.Notes,
                        SubmittedBy: formData.SubmittedBy,
                        NextSlip: formData.NextSlip,
                        Tie: formData.Tie,
                        order_for: formData.order_for,
                        Pant: formData.Pant,
                        shoe_color: formData.shoe_color,
                        belt: formData.belt,
                        Coat: formData.Coat,
                        Shirt: formData.Shirt,
                        Vest: formData.Vest,
                        dropShippingswitch: formData.dropShippingswitch,

                    }}
                    isSubmitting={isSubmitting}

                />
            )}


            {step == 4 && (
                <MemberOrderReview
                    key="step5"
                    onRewSubmit={onFinalSubmit}
                    onSubmit={onFormSubmit}
                    RestShirtSubmit={RestShirt}
                    ResetVest={ResetVest}
                    ResetShoe={ResetShoe}
                    setForStatus={setForStatus}
                    ResetJewelry={ResetJewelry}
                    RecetTie={RecetTie}
                    RecetPocket={RecetPocket}
                    RecetCoat={RecetCoat}
                    RecetPant={RecetPant}
                    onBack={onBackStep}
                    refid={memberId}
                    showShirt={showShirt}
                    setShowShirt={setShowShirt}
                    showVest={showVest}
                    setShowVest={setShowVest}
                    showShoes={showShoes}
                    setShowShoes={setShowShoes}
                    setShowTie={setShowTie}
                    showTie={showTie}
                    setShowPocket={setShowPocket}
                    ShowPocket={ShowPocket}
                    CopyOrder={CopyOrder}
                    setCopyOrder={setCopyOrder}
                    setShowjewelry={setShowjewelry}
                    Showjewelry={Showjewelry}

                    Showcoat={Showcoat}
                    setShowcoat={setShowcoat}

                    ShowPant={ShowPant}
                    setShowPant={setShowPant}
                    isSubmitting={isSubmitting}

                    initialValues={{
                        Weddingdate: formData.Weddingdate,
                        order_type: formData.order_type,
                        Firstname: formData.Firstname,
                        Lastname: formData.Lastname,
                        Address: formData.Address,
                        State: formData.State,
                        City: formData.City,
                        ZipCode: formData.ZipCode,
                        PhoneNumber: formData.PhoneNumber,
                        EmailAddress: formData.EmailAddress,
                        school: formData.school,

                        dropShipping: formData.dropShipping,
                        dropShippingswitch: formData.dropShippingswitch,
                        AlternatePickup: formData.AlternatePickup,
                        Affiliated_store: formData.Affiliated_store,
                        store_id: formData.store_id,


                        Height: formData.Height,
                        Weight: formData.Weight,
                        Weightwo: formData.Weightwo,
                        Overarm: formData.Overarm,
                        Coat: formData.Coat,
                        CoatSize: formData.CoatSize,
                        Insleeve: formData.Insleeve,
                        Pant: formData.Pant,

                        PantSize: formData.PantSize,
                        Shirt: formData.Shirt,
                        ShirtSize: formData.ShirtSize,
                        Sleeve: formData.Sleeve,
                        Vest: formData.Vest,
                        VestColor: formData.VestColor,
                        Tie: formData.Tie,
                        Pocket: formData.Pocket,
                        Jewelry: formData.Jewelry,
                        Shoes: formData.Shoes,
                        ShoesSize: formData.ShoesSize,
                        outseam: formData.outseam,
                        Chest: formData.Chest,
                        style: formData.style,
                        hip: formData.hip,
                        Rentalterm: formData.Rentalterm,
                        order_for: formData.order_for,
                        Waist: formData.Waist,
                        size_chart_id: formData.size_chart_id,

                        Notes: formData.Notes,
                        SubmittedBy: formData.SubmittedBy,
                        NextSlip: formData.NextSlip,
                    }}
                />
            )}

        </div>
    )
}

export default MemberParent
